import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { ReconcileOneResult, ReconcileRunResult } from '../../../models/risk/risk.model';
import useHttps from '../../useHttps';

// Same read-only settle the 10-minute cron runs: re-reads Paystack/VTpass and
// refunds where needed — it never charges a card or buys anything.
const useRunReconciliation = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Reconciliation failed');
  };

  const runAll = (onDone?: () => void) => {
    request(
      { url: 'api/v1/admin/reconciliation/run', method: 'post' },
      ({ data }: SuccessHttpResponse<ReconcileRunResult>) => {
        toast.success(
          data.checked
            ? `Checked ${data.checked}, settled ${data.resolved}` +
                (data.escalated ? `, escalated ${data.escalated}` : '')
            : 'Nothing ready to reconcile yet'
        );
        onDone?.();
      },
      setLoading,
      onError
    );
  };

  const runOne = (reference: string, onDone?: (result: ReconcileOneResult) => void) => {
    request(
      { url: `api/v1/admin/reconciliation/transactions/${reference}`, method: 'post' },
      ({ data, message }: SuccessHttpResponse<ReconcileOneResult>) => {
        if (data.resolved) toast.success(`${message} — now ${data.status}`);
        else toast(message);
        onDone?.(data);
      },
      setLoading,
      onError
    );
  };

  return { loading, runAll, runOne };
};

export default useRunReconciliation;
